export default [
    {
        path: "/bank-soal/irt-calibration",
        name: "irt-calibration",
        component: () =>
            import("@/views/dashboard/bank-soal/irt-calibration/index.vue"),
        meta: {
            pageTitle: "IRT Calibration",
            breadcrumb: [
                {
                    text: "Manajemen Paket",
                },
                {
                    text: "IRT Calibration",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/bank-soal/irt-calibration/:id",
        name: "irt-calibration-detail",
        component: () =>
            import("@/views/dashboard/bank-soal/irt-calibration/detail.vue"),
        meta: {
            pageTitle: "IRT Parameters",
            breadcrumb: [
                {
                    text: "Manajemen Paket",
                },
                {
                    text: "IRT Calibration",
                    to: { name: "irt-calibration" },
                },
                {
                    text: "Parameters",
                    active: true,
                },
            ],
        },
    },
];

